import { api } from "./client";

export type EmailTemplateSummary = {
  id: string;
  name: string;
  createdAt: string;
};

export type EmailTemplateDetail = EmailTemplateSummary & {
  html: string;
};

export function listEmailTemplates(): Promise<{ templates: EmailTemplateSummary[] }> {
  return api(`/email-templates`);
}

export function getEmailTemplate(id: string): Promise<{ template: EmailTemplateDetail }> {
  return api(`/email-templates/${id}`);
}

export function createEmailTemplate(input: {
  name: string;
  html: string;
}): Promise<{ template: EmailTemplateSummary }> {
  return api(`/email-templates`, { method: "POST", body: input });
}

export function deleteEmailTemplate(id: string): Promise<{ deleted: number }> {
  return api(`/email-templates/${id}`, { method: "DELETE" });
}
